import { LOADER_STATUS,SET_CURRENT_PAGE,SET_PAGE_COUNT, SET_PAGE_DATA } from './constants';

// const data = [

//     {

//         "company_name": "ABC Pvt Ltd",

//         "company_id": 0,

//         "users": [

//         ]

//     },

//     {

//         "company_name": "GT ",

//         "company_id": 32,

//         "users": [

//             {

//                 "emails": "dummy.test@xyz.com",

//                 "name": "Ajit roy",

//                 "gstin_data": [

//                     {

//                         "gstin": "33GSPTN1351G1ZF",

//                         "status": "Inactive",

//                         "modified_date": "2023-05-09T06:17:11.000Z"

//                     },

//                     {

//                         "gstin": "33DFLPR3450C3ZJ",

//                         "status": "Inactive",

//                         "modified_date": "2023-02-17T18:36:23.000Z"

//                     },

//                     {

//                         "gstin": "33AAGCC7144L6ZE",

//                         "status": "Inactive",

//                         "modified_date": "2023-02-17T08:57:22.000Z"

//                     },

//                     {

//                         "gstin": "33DFLPR3450C4ZI",

//                         "status": "Inactive",

//                         "modified_date": null

//                     },

//                     {

//                         "gstin": "33ABHCS8661G1Z3",

//                         "status": "Inactive",

//                         "modified_date": null

//                     }

//                 ]

//             },

//             {

//                 "emails": "gtb@test.com",

//                 "name": "GrantThronton Bharat",

//                 "gstin_data": [

//                     {

//                         "gstin": "27AACFG9740K1Z2",

//                         "status": "Inactive",

//                         "modified_date": null

//                     }

//                 ]

//             }

//         ]

//     }

// ];

export const initialState = {
    loaderStatus: false,
    totalPages: 0,
    pageData: [],
    totalRecords: 0,
    currentPage: 0,
};
const adminGSTINReportReducer = (state = initialState, action) =>{
    switch (action.type) {
        case LOADER_STATUS:
            return {
                ...state,
                loaderStatus:action.loaderStatus
            }
        case SET_PAGE_COUNT:
            return {
                ...state,
                totalPages:action.count
            }
            case SET_PAGE_DATA:
                return {
                  ...state,
                  totalRecords:action.data.total_Records,
                  pageData: action.data.data
                }
            case SET_CURRENT_PAGE:
                return {
                  ...state,
                  currentPage:action.currentPage
                }
        default:
            return state; 
    }
}
        

export default adminGSTINReportReducer;